"use client";
import Image from "next/image";
import styles from "@/styles/menu.module.scss";
import Link from "next/link";
import { ItemObj } from "../modals/order-details-sheet";
import { removeSpacesFromString } from "_services/common.service";
import { cookingLoadingService } from "_services/loadingCooking.service";
import { event } from "@lib/ga";

interface CategoryImage {
  imageUrl: string;
}

export interface Category {
  categoryId: number;
  categoryName: string;
  categoryImageUrls: CategoryImage[];
  subCategories: Category[];
  items: ItemObj[];
  categoryType: string;
  parentIndex?: number;
}

export default function CategoryCard(props: { 
  category: Category, 
  cardId?: string,
  active?: boolean, 
  isScrollCategory?: boolean
}) {
  const { category, active, isScrollCategory, cardId } = props;
  // console.log(category);
  

  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    
    if (isScrollCategory) {
      event({
        action: 'scroll_to_category',
        category: 'category_navigation',
        label: category.categoryName,
      });

      e.preventDefault();
      const element = document.getElementById(`category-${category.categoryId}`);
      if (element) {
        document.getElementById("main")?.scrollTo({  //menu-container
          behavior: "smooth",
          top: element.offsetTop - 180 // Adjust for fixed navbar height
        });
      }
    } else{
      // Show loading for all category clicks (scroll or navigate)
      cookingLoadingService.loading(true);

      event({
        action: 'navigate_to_category',
        category: 'category_navigation',
        label: category.categoryName,
      });
    }
  }

  // console.log(category);
  
  return (
  <Link 
    href={(isScrollCategory ? `#` : `/menu/${category.categoryName}`)} 
    id={cardId || `category-link-${category.categoryId}`} 
    data-category={removeSpacesFromString(category.categoryName)}
    onClick={(e) => handleClick(e)}
    >
    <div className={`${styles.categoryCard} ${active ? styles.active : ""}`}>
      <div className={styles.imageContainer}>
        <Image
          src={category.categoryImageUrls?.[0]?.imageUrl || '/assets/images/placeholder.png'}
          alt={category.categoryName}
          width={52}
          height={52}
          onError={(e) => { (e.target as HTMLImageElement).src = '/assets/images/placeholder.png'; }}
        />  
      </div>
      <span>{category.categoryName}</span>
    </div>
  </Link>);
}

